import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

const TopMenuContainer = styled.div`
    grid-row: 1;
    align-self: center;
    justify-self: center;
    width: 100%;
    display: grid;
    grid-template-columns: 1fr;
    align-items: center;
`

const LogoLink = styled(Link)`
    display: inline-flex;
    align-items: center;
    text-decoration: none;

    &:hover {
        opacity: 0.9;
    }
`

const LogoImg = styled.img`
    height: 120px;
    width: auto;
    display: block;
    object-fit: contain;
`

export default function TopMenu() {
    return (
        <TopMenuContainer>
            <LogoLink to="/">
                <LogoImg src={`${process.env.PUBLIC_URL || ''}/assets/logo.png`} alt="DropScore" />
            </LogoLink>
        </TopMenuContainer>
    )
}




// WEBPACK FOOTER //
// ./src/components/TopMenu.js